<form class="admin-form" enctype="multipart/form-data">
  <input type="file" (change)="pickImage($event)" id="profile" name="profile">
  <input type="submit" value="Submit" (click)="imageUpload()">
</form>
